var _g, _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgCustomerSupport(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 30,
    height: 30,
    viewBox: "0 0 30 30",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_13_410)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M2.77832 13.8903H5.00076C5.00076 13.8903 5.3045 13.8962 5.58823 14.0377C5.87196 14.1799 6.11198 14.3533 6.11198 15.0015V21.6658C6.11198 22.3141 5.87196 22.4874 5.58823 22.6296C5.3045 22.7741 5.00076 22.7771 5.00076 22.7771H2.77832V13.8903Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M15.0015 0C7.82747 0 1.97059 5.6776 1.67871 12.779H2.78993C3.07885 6.27988 8.42975 1.11122 15.0015 1.11122C21.5733 1.11122 26.9242 6.27988 27.2131 12.779H28.3273C28.0354 5.6776 22.1726 0 15.0015 0Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M25.0283 13.8903H27.2277V22.7771H25.0023C24.3541 22.7771 24.1808 22.537 24.0385 22.2533C23.8963 21.9696 23.8911 21.6658 23.8911 21.6658V15.0274C23.8911 15.0274 23.9082 14.7437 24.0593 14.4577C24.2126 14.171 24.4149 13.9162 25.0283 13.8903Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1.66688 15.3459V21.3273L0.555664 20.7687V15.9016L1.66688 15.3459Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M28.3394 15.3459L29.4446 15.9016V20.7687L28.3394 21.3214V15.3459Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M13.8872 28.8947H16.1126V30H13.8872V28.8947Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M15.0014 17.7795C15.314 17.7795 15.557 18.0225 15.557 18.3352C15.557 18.6507 15.314 18.8908 15.0014 18.8908C14.6858 18.8908 14.4458 18.6507 14.4458 18.3352C14.4458 18.0225 14.6858 17.7795 15.0014 17.7795Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M19.4462 17.7795C19.7588 17.7795 20.0048 18.0225 20.0048 18.3352C20.0048 18.6507 19.7588 18.8908 19.4462 18.8908C19.1336 18.8908 18.8936 18.6507 18.8936 18.3352C18.8936 18.0225 19.1336 17.7795 19.4462 17.7795Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M10.5596 17.7795C10.8722 17.7795 11.1122 18.0225 11.1122 18.3352C11.1122 18.6507 10.8722 18.8908 10.5596 18.8908C10.244 18.8908 10.001 18.6507 10.001 18.3352C10.001 18.0225 10.244 17.7795 10.5596 17.7795Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M24.9767 23.8912C24.6989 26.7041 22.335 28.8947 19.4466 28.8947H17.2241V30H19.4466C22.9365 30 25.8072 27.3086 26.0909 23.8912H24.9767Z",
    fill: "white"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_13_410"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 30,
    height: 30,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCustomerSupport);
export default __webpack_public_path__ + "static/media/customer-support.50aa20d15d800f62a18bc82ea72da1b5.svg";
export { ForwardRef as ReactComponent };